module.exports = __webpack_public_path__ + "img/icon_goumaili_fundAllocation.03e4c18c.png";